import {
  buildHeader,
  buildParagraph,
  renderElementToImageRunById,
  buildNewlines,
  buildInlineHeader,
  buildInlineParagraph,
} from "./helpers";
import { AlignmentType } from "docx";

const createSectionMasteryProgress = async (
  studentData,
  weeklyPlan,
  metrics,
  progressReportId
) => [
  // Student's Mastery Progress Header
  buildHeader(`${studentData.firstName}'s Mastery Progress`, 3),
  // Overall, {Student First Name} is showing {Percentile} Level Growth
  buildInlineHeader(
    [
      {
        text: `[TODO] [Mock: Overall, Maria is showing] `,
        bold: true,
      },
      {
        text: `[${metrics.percentileGrowth}]`,
        // TODO: Programmatically set color based on percentile growth
        color: "3a7d22",
        bold: true,
      },
      {
        text: ` [Level Growth.]`,
        bold: true,
      },
    ],
    3,
    true
  ),
  ...buildNewlines(1),
  // The Intelligent Growth Engine Recommends: {IGE Recommendations}
  buildInlineParagraph([
    {
      text: `The Intelligent Growth Engine Recommends: `,
      italics: true,
    },
    {
      text: `[TODO] [Mock: Keep Doing What We Are Doing.  The plan is working.]`,
      italics: true,
      bold: true,
    },
  ]),
  ...buildNewlines(1),
  // IGE Overview
  buildParagraph(
    `[TODO] [Mock: Maria continues to progress at the expected pace. Her ARM score grew an estimated 0.1 points, slightly above her growth rate this year.]`
  ),
  // Progress summary image
  ...buildNewlines(4),
  buildParagraph("[TODO] [Placeholder: Progress Summary Image]", {
    italics: true,
  }),
  ...buildNewlines(4),
  buildParagraph(
    "[TODO] [Placeholder: ProgressReport Render] [Works when data is available, uncomment needed blocks in IRIPDocumentGenerator.js to generate.  Use following code:]"
  ),
  buildParagraph("await renderElementToImageRunById(progressReportId)"),
  ...buildNewlines(4),
];

export default createSectionMasteryProgress;
